import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { DimensionOptionResultDto } from '../cirabooks/shared-cirabooks-module/_models/common/dimensions/dimension-option-result-dto';
const ɵ0 = () => DimensionOptionResultDto;
export class BankAccountSelectorResultDto {
    constructor() {
        this.glDimensions = [];
        // Transient
        this.dimensionDisplayText = '';
    }
    get displayBankName() {
        return `${this.bankName};${this.accountName};${this.accountNumber}; ${this.dimensionDisplayText}`;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], BankAccountSelectorResultDto.prototype, "glDimensions", void 0);
export { ɵ0 };
